module.exports = __webpack_public_path__ + "static/media/modal-onclick.cb0ce012.svg";